import { STEP_GROUPS, type StepGroup } from "./features/task-steps/stepGroups.ts";

const DELEGATED_REVIEWS_PATH_PREFIX = "/reviews";

export const delegatedReviewsPaths = {
    landing: DELEGATED_REVIEWS_PATH_PREFIX,
    notification: `${DELEGATED_REVIEWS_PATH_PREFIX}/notification/:notificationId`,
    tasks: `${DELEGATED_REVIEWS_PATH_PREFIX}/tasks`,
    taskReview: `${DELEGATED_REVIEWS_PATH_PREFIX}/tasks/:taskId`,
    unavailable: `${DELEGATED_REVIEWS_PATH_PREFIX}/unavailable`
} as const;

const stepGroupSlug: Record<StepGroup, string> = {
    lifecycle: "lifecycle",
    sharingLinks: "sharing-links",
    membership: "membership",
    files: "files"
};

export const legacyExternalSharingSlug = "external-sharing";
export const legacyGuestsSlug = "guests";

const legacyStepGroupSlug: Record<StepGroup, string> = {
    lifecycle: "lifecycle",
    sharingLinks: legacyExternalSharingSlug,
    membership: legacyGuestsSlug,
    files: "files"
};

export function stepGroupOfSlug(slug: string): StepGroup | undefined {
    return STEP_GROUPS.find(step => stepGroupSlug[step] === slug || legacyStepGroupSlug[step] === slug);
}

export const taskReviewStepPath = (taskId: string, step: StepGroup): string =>
    `${DELEGATED_REVIEWS_PATH_PREFIX}/tasks/${taskId}/${stepGroupSlug[step]}`;
